import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";

import App from './App';
import './index.scss';

// Always use createRoot — never hydrateRoot.
//
// react-snap (Puppeteer 1.x, pre-React 18) snapshots a React 18 createRoot
// render. The resulting DOM does NOT match what renderToString would produce,
// so hydrateRoot causes a mismatch: PersistGate's initial `null` render vs
// the full pre-rendered page. React then keeps BOTH trees in the DOM →
// page renders twice + event delegation breaks (buttons dead, no errors).
//
// createRoot always replaces the container with a clean React tree.
// Crawlers / social-link previewers that don't run JS still benefit from the
// pre-rendered HTML that react-snap wrote to build/index.html.
createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </HelmetProvider>
);